import { QueryClient } from '@tanstack/react-query'
import { INotificationContentHandler } from '@/lib/handler/notification-content-handler'
import { NotificationType } from '@/types/notification'
import { DashboardResponseType } from '@/types/dashboard'

/**
 * Contact Form Messages Content Handler
 * When a new contact form message notification arrives via WebSocket:
 * - Updates the dashboard cache directly (increments unreadContactFormMessages) — no API refetch
 * - Invalidates the contact-form-messages list only if it's currently active (page is open)
 */
export default class ContactFormMessagesContentHandler implements INotificationContentHandler {
  handle(_notification: NotificationType, queryClient: QueryClient): void {
    // Increment unread count directly in the dashboard cache without triggering a network request
    queryClient.setQueryData<DashboardResponseType>(['dashboard'], old => {
      if (!old?.stats) {
        return old
      }
      return {
        ...old,
        stats: {
          ...old.stats,
          unreadContactFormMessages: (old.stats.unreadContactFormMessages ?? 0) + 1
        }
      }
    })

    // Refresh the list only if the contact messages page is currently open
    void queryClient.invalidateQueries({
      queryKey: ['contact-form-messages'],
      refetchType: 'active'
    })
  }
}
